import { Box } from '@factorialco/deprecated-design-system'
import { Spinner } from '@factorialco/f0-react/dist/experimental'

export const LoadingBlock = () => {
  return (
    <Box alignItems="center" justifyContent="center" height="full">
      <Spinner />
    </Box>
  )
}
